import { Dayjs } from 'dayjs';
import dayjs from '../dayjs/dayjs';
import { getLocalTimeZone } from '../time-zones.utils';

export const getShiftDayValue = (
	date: Date | Dayjs,
	shiftBack = false,
	timezone = getLocalTimeZone(),
) => {
	// Parse the date in the timezone and apply UTC without changing the time
	const time = dayjs(dayjs(date).tz(timezone).utcOffset(0, true).format()).utc();
	const utcTime = dayjs(date).utc();

  const shiftValue = utcTime.diff(time, 'days', true) > 0 ? 1 : -1;

  return shiftBack ? -shiftValue : shiftValue;
};
